import {
  IgBasePrimitives,
  IgGreenPrimitives,
  IgTonalBackgroundColors,
  IgTonalTextColors,
} from "@intelligems/ig-design-tokens/constants";
import { IgChip } from "@intelligems/ig-theme/IgChip";
import type { SxProps, Theme } from "@mui/material";

type GateChipTone = "module" | "savings" | "warning";

const TONE_SX: Record<GateChipTone, SxProps<Theme>> = {
  module: {
    backgroundColor: IgBasePrimitives[50],
    color: IgBasePrimitives[500],
  },
  savings: {
    backgroundColor: IgGreenPrimitives[200],
    color: IgGreenPrimitives.A300,
  },
  warning: {
    backgroundColor: IgTonalBackgroundColors.warning,
    color: IgTonalTextColors.warning,
  },
};

type GateChipProps = Readonly<{
  label: string;
  tone?: GateChipTone;
  sx?: SxProps<Theme>;
}>;

export const GateChip = ({ label, tone = "module", sx }: GateChipProps) => (
  <IgChip
    color="secondary"
    label={label}
    sx={[
      {
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.5px",
        px: "10px",
        py: "4px",
        textTransform: "uppercase",
      },
      TONE_SX[tone],
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);
